module.exports = __webpack_public_path__ + "img/product-placeholder-42.19529ec.png";